import { Component, ViewEncapsulation } from "@angular/core";
import { MessageService } from "primeng/api";
import { FaqItem } from "../../interfaces/interfaces";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-faqsort',
    templateUrl: './faqsort.component.html',
    styleUrls: ['faqsort.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FaqSortComponent {

    faqItems: FaqItem[] = [];

    loadFaqs(): void {
        this.apiService.getSimpleTable<FaqItem>('faq', {
            filters: {},
            first: 0,
            rows: -1,
            sortField: 'sortIndex',
            sortOrder: 1
        }).subscribe(({data}) => {
            this.faqItems = data;
        });
    }

    save(): void {
        this.apiService.sortFaq(this.faqItems.map((faqItem: FaqItem) => faqItem.id)).subscribe(() => {
            this.messageService.add({
              severity: 'success',
              summary: 'Rendezés',
              detail: 'Sikeres rendezés'
            });
        });
    }

    constructor(
        private apiService: ApiService,
        private messageService: MessageService
    ) {
        this.loadFaqs();
    }
}